import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
} from "@mui/material";
import { useIsDesktop } from "./hooks/useIsDesktop";
import { FONT_SIZE } from "../../constants/fontSizes";

/**
 * タイトル・本文・アクションボタンを表示する汎用モーダル
 */
const PopupModal = ({
  open,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel,
  cancelLabel = "キャンセル",
  isSubmitting = false,
  maxWidth = "sm",
  hideCancelButton = false,
}) => {
  const isDesktop = useIsDesktop();

  const handleClose = (event, reason) => {
    if (isSubmitting) return;

    onClose?.(event, reason);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={isSubmitting}
      fullWidth
      maxWidth={maxWidth}
    >
      {title && <DialogTitle sx={{ fontWeight: "bold" }}>{title}</DialogTitle>}

      <DialogContent>{children}</DialogContent>

      {(onConfirm || !hideCancelButton) && (
        <DialogActions
          sx={{
            px: { xs: 2, sm: 4 },
            pt: 1,
            pb: 3,
            flexShrink: 0,
          }}
        >
          <Stack spacing={1} width="100%">
            {onConfirm && (
              <Button
                fullWidth
                onClick={onConfirm}
                disabled={isSubmitting}
                variant="contained"
                sx={{
                  borderRadius: 9999,
                  px: 1,
                  fontWeight: "bold",
                  color: "#fff",
                  minHeight: 48,
                  fontSize: isDesktop ? FONT_SIZE.BASE : FONT_SIZE.SM,
                  "&:hover": {
                    bgcolor: "primary.dark",
                  },
                }}
              >
                {isSubmitting ? "処理中..." : confirmLabel}
              </Button>
            )}

            {!hideCancelButton && (
              <Button
                fullWidth
                onClick={handleClose}
                disabled={isSubmitting}
                variant="outlined"
                sx={{
                  borderRadius: 9999,
                  minHeight: 48,
                  fontSize: isDesktop ? FONT_SIZE.BASE : FONT_SIZE.SM,
                }}
              >
                {cancelLabel}
              </Button>
            )}
          </Stack>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default PopupModal;
